import { render, staticRenderFns } from "./select-workspace.vue?vue&type=template&id=1ac39312&scoped=true&"
import script from "./select-workspace.vue?vue&type=script&lang=js&"
export * from "./select-workspace.vue?vue&type=script&lang=js&"
import style0 from "./select-workspace.vue?vue&type=style&index=0&lang=css&"
import style1 from "./select-workspace.vue?vue&type=style&index=1&id=1ac39312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac39312",
  null
  
)

/* custom blocks */
import block0 from "./select-workspace.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports